import { render } from "./TripDetail.vue?vue&type=template&id=72f7a9fe&scoped=true"
import script from "./TripDetail.vue?vue&type=script&lang=js"
export * from "./TripDetail.vue?vue&type=script&lang=js"

import "./TripDetail.vue?vue&type=style&index=0&id=72f7a9fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f7a9fe"]])

export default __exports__